package cz.vojtechhoranek.site.localization

import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.events.Event

internal fun textForLanguages(languages: List<String>): SiteText {
    for (language in languages) {
        when (language.trim().lowercase().substringBefore('-').substringBefore('_')) {
            "cs" -> return CzechText
            "en" -> return EnglishText
        }
    }
    return EnglishText
}

private fun browserText(): SiteText {
    val navigator = window.navigator
    return textForLanguages(navigator.languages.toList().ifEmpty { listOf(navigator.language) })
}

@Composable
fun BrowserLanguage(content: @Composable () -> Unit) {
    var text by remember { mutableStateOf(browserText()) }

    DisposableEffect(Unit) {
        val onLanguageChange: (Event) -> Unit = { text = browserText() }
        window.addEventListener("languagechange", onLanguageChange)
        onDispose { window.removeEventListener("languagechange", onLanguageChange) }
    }

    LaunchedEffect(text.languageTag) {
        document.documentElement?.setAttribute("lang", text.languageTag)
        document.querySelector("meta[name='description']")?.setAttribute("content", text.description)
    }

    CompositionLocalProvider(LocalSiteText provides text, content = content)
}
